import React from "react";
import UploadFilesService from '../services/UploadFilesService ';
import uploadIcon from './../assets/img/upload.svg'
import { FileUploader } from "react-drag-drop-files";
import { fix_numbers } from "../helper";

export class UploadEncrypt extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      selectedFiles: undefined,
      currentFile: undefined,
      progress: 0,
      message: "",
      fileInfos: [],
      allowError: '',
      disabled: true,
      loading: false,
      btnText: 'Encrypt',
      statusMessage: '',
      status: 'encrypt',
      downloadLink: '',
      password: '',
    };

  }

  handleChange(file) {
    this.afterSelectFile(file);
    this.selectFile(file)
  };

  render() {
    const { classes } = this.props
    return (
      <div className={`${classes}`} >
        <div className='card neo-out rounded-md'>
          <div className='card__header'>
            <span className='card__title'>Image Encryption</span>
            <span className='card__desc'>Attach your file</span>
          </div>
          <div className='card__body mb-5'>
            <div className='upload '>
              <FileUploader classes="upload__box cursor-pointer relative" multiple={true} handleChange={this.handleChange.bind(this)} name="file"  >
                <img className='upload__icon' src={uploadIcon} alt="" />
                <div className='upload__title'>
                  <span className='hidden lg:block'>Drop your file or click to upload</span>
                  <span className='lg:hidden'>Click to upload your file</span>
                </div>
              </FileUploader>
              <span className="upload__filename-encrypt"></span>
              <div className="input__box">
                <svg title="Upload another file" className={`${this.state.status == "download" ? '' : 'hidden'} h-6 w-6 `}  fill="none" viewBox="0 0 24 24" stroke="#7d86a3" strokeWidth="2" >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <input type="password" disabled={this.state.status == "download" ? true : false} onChange={(e) => { this.setState({ password: e.target.value }, () => { this.encryptAllow() }) }} className="input neo-in _encrypt-password" placeholder="Enter your secret key" />
              </div>
            </div>
          </div>
          <div className='card__footer flex flex-col gap-y-3 md:flex-row md:items-center'>

            <button onClick={this.state.status === 'encrypt' ? this.encrypt.bind(this) : this.downloadFile.bind(this)}
              className={`${this.state.progress == 100 ? 'text-success' : 'text-danger'} btn btn-primary text-danger text-sm neo-out mb-1  btn-with-loader order-2 md:order-1`}
              style={{ "--loader-width": `${this.state.progress}%`, "--loader-bg": `${this.state.progress == 100 ? 'green' : 'red'}` }}
              disabled={this.state.disabled}  >
              <span className={this.state.loading ? 'hidden' : ''}>{this.state.btnText}</span>
              <div className={`${!this.state.loading ? 'hidden' : ''} neu-loader  `}>
                <span className="elem"></span>
                <span className="elem"></span>
                <span className="elem"></span>
                <span className="elem"></span>
                <span className="elem"></span>
              </div>
            </button>
            <span className={`order-1 md:order-2 card__message ${this.state.status !== 'download' ? 'text-danger font-bold' : ''} ${this.state.statusMessage ? 'active' : ''}`}>{this.state.statusMessage}</span>
          </div>
        </div>
      </div>
    )
  }

  retry() {
    this.setState({
      selectedFiles: undefined,
      currentFile: undefined,
      progress: 0,
      message: "",
      fileInfos: [],
      allowError: '',
      disabled: true,
      loading: false,
      btnText: 'Encrypt',
      statusMessage: '',
      status: 'encrypt',
      downloadLink: '',
    })
  }

  downloadFile() {
    window.open(
      `//${this.state.downloadLink}`,
      '_blank' // <- This is what makes it open in a new window.
    );
  }

  loader(status = "on") {
    status === "on"
      ? this.setState({ loading: true })
      : this.setState({ loading: false })
  }

  encryptAllow() {
    // Prevent reset every thing if user clicked on cancel button in download state
    if (!this.state.selectedFiles || (this.state.selectedFiles && !this.state.selectedFiles.length) && this.state.status == 'download') return;
    if (this.state.status == "download") return;
    this.state.selectedFiles.length && this.state.password
      ? this.setState({ disabled: false })
      : this.setState({ disabled: true })
  }

  afterSelectFile(file) {
    let fileNameEl = document.querySelector(".upload__filename-encrypt")

    // Prevent reset every thing if user clicked on cancel button in download state
    if (file.length) {
      this.retry();
      fileNameEl.innerHTML = `File name: ${file[0].name}`;
      fileNameEl.classList.add('active')
    }
    else if (!file.length && this.state.status != 'download') {
      fileNameEl.innerHTML = '';
      fileNameEl.classList.remove('active')
    }
  }

  valid() {
    if ((this.state.selectedFiles[0].size / 1024) / 1024 >= 11) {
      this.setState({
        statusMessage: "Maximum allow file is 10MB"
      });
      return false
    }
    if (!['jpeg', 'jpg', 'png'].includes(this.state.selectedFiles[0].type.split('/')[1])) {
      this.setState({
        statusMessage: "Only supports jpeg,jpg,png"
      });
      return false
    }

    return true;
  }

  encrypt(e) {
    if (this.state.loading || this.state.disabled || !this.valid()) return;

    let currentFile = this.state.selectedFiles[0];
    this.setState({
      progress: 0,
      currentFile: currentFile,
    });

    this.loader('on')

    // Abort current request
    window.stop();
    let password = fix_numbers(this.state.password);
    UploadFilesService.uploadEncrypt({ file: currentFile, password }, (event) => {
      this.setState({
        progress: Math.round((100 * event.loaded) / event.total) > 90 ? 90 : Math.round((100 * event.loaded) / event.total),
      });
    })
      .then((res) => {
        const { userpic: downloadLink } = res.data.value;
        const { success, status } = res.data
        if (success === true && status === 200) {
          this.setState({
            progress: 100,
            statusMessage: 'Done,click to download :)',
            btnText: 'Download',
            status: 'download',
            downloadLink,
          })
        }
        this.loader('off')
      })
      .catch((err) => {
        let { Message: message } = err.response.data;
        this.setState({ progress: 0, statusMessage: message ?? "Some thing went wrong :(" })
        this.loader('off')
      });

  }

  selectFile(file) {
    this.setState({
      selectedFiles: file,
    }, () => {
      this.encryptAllow()
    });
  }

}

export default UploadEncrypt